import React, { useEffect, useState, useCallback } from 'react';
import {
  KoButton,
  KoForm,
  KoImage,
  KoLoader,
  KoModal,
  KoPagination,
  KoTable,
  KoText,
  KoTitle,
  KoToast,
  KoTooltips
} from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './category.module.scss';
import { OrdersAPI } from '../../../orders.service';

import KoToolBar from 'shared/components/toolbar';
import ProductObject from '../constant';
import ChildCategoryForm from './childCategoryForm';


export default function ChildCategoryDetails() {

  const [form] = KoForm.useForm();
  const [selectedCategoryId] = useState(null);
  const [selectedSubCategoryId] = useState(null);
  const [childCategoryList, setChildCategoryList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [createChildCategory, setCreateChildCategory] = useState(false);
  const [pagination, setPagination] = useState({
    size: 100,
    page: 1
  });

  const getChildCategory = useCallback(() => {
    if (!selectedCategoryId || !selectedSubCategoryId) return;
    setLoading(true);
    OrdersAPI.getChildCategory(selectedCategoryId, selectedSubCategoryId)
      .then((res) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        setChildCategoryList(rows);
        setTotalCount(rows.length);
      })
      .catch(() => {
        setChildCategoryList([]);
        setTotalCount(0);
      })
      .finally(() => setLoading(false));
  }, [selectedCategoryId, selectedSubCategoryId]);

  useEffect(() => {
    getChildCategory();
  }, [getChildCategory]);

  const handleFinish = async(values) => {
    if (!selectedCategoryId || !selectedSubCategoryId) {
      KoToast.error("Category & SubCategory are required");
      return;
    }
    try {
      setLoading(true);
      await OrdersAPI.createChildCategory(
        selectedCategoryId,
        selectedSubCategoryId,
        values
      );

      KoToast.success("Child Category Created");
      form.resetFields();
      setCreateChildCategory(false);
      getChildCategory();

    } catch (error) {
      console.error(error);
      KoToast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const onPagination = (page, pageSize) => {
    setPagination({ page, size: pageSize });
  };

  const columnsRight = [
    {
      title: '',
      key: 'actions',
      fixed: 'right',
      width: 40,
      render: () => (
        <div className={`${styles.table} tableBtn columnsRight`}>
          <KoTooltips title="View">
            <KoButton
              size="small"
              iconBtn
              icon={<KoIcon width={14} height={14} name="OpenOutlined" />}
              // onClick={() => setCategoryDetails(true)}
            />
          </KoTooltips>
        </div>
      )
    }
  ];

  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <div className={styles.bodyContent}>
        <div className={styles.CategoryDetails}>
          <div className={styles.CategoryDetailsImage}>
            <KoImage
              alt={"name"}
              src={"/images/mouse.png"}
              width={200}
              height={200}
              preview={false}
            />
          </div>

          <div className={styles.CategoryDetailsContent}>
            <div className={styles.productName}>
              <KoTitle level={4} text={"Mouse"} />
            </div>

            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"ProcessingOutlined"} width={20} height={20} />
                <KoText  className={styles.title} text={"Product"} />
              </div>
              <KoText className={styles.value} level={5} text={"88"} />
            </div>

            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"TotalStockOutlined"} width={20} height={20} />
                <KoText className={styles.title} text={"Stock"} />
              </div>
              <KoText
                level={5}
                className={styles.value}
                text={"812"}
              />
            </div>

            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"OrderDescriptionOutlined"} width={20} height={20} />
                <KoText  className={styles.title} text={"Description"} />
              </div>
              <KoText
                className={styles.value}
                level={5}
                text={
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                }
              />
            </div>

            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"OrderDateOutlined"} width={20} height={20} />
                <KoText className={styles.title} text={"Created"} />
              </div>
              <KoText
                level={5}
                className={styles.value}
                text={"14 January 2024, 10:00"}
              />
            </div>
          </div>
        </div>

        <div className={styles.CategoryTable}>
          <div className={styles.deletebtn}>
            {/* <div className={`${styles.wrapper} profileSection`}> */}
            <KoToolBar
              title=""
              search={{ visible: true, onChange: () => {}, placeholder: 'Search' }}
              buttonList={[
                {
                  label: 'Create',
                  type: 'primary',
                  icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />,
                  onClick: () => setCreateChildCategory(true)
                }
              ]}
            />
          </div>
          {/* </div> */}

          <KoTable
            extraColumnsRight={columnsRight}
            maxHeight={77}
            data={{
              columns: ProductObject.CAT_COLUMN,
              rows: childCategoryList
            }}
          />



          <KoModal
            title={
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <KoIcon width={24} height={24} name="plusOutlined" />
                <span style={{ fontWeight: 500 }}>childCreateCategory</span>
              </div>
            }
            centered
            open={createChildCategory}
            onClose={() => setCreateChildCategory(false)}
            width={"30vw"}
            maskClosable={false}
            height={450}
            footer={[
              <KoButton
                key="cancel"
                label="Cancel"
                onClick={() => setCreateChildCategory(false)}
              />,
              <KoButton
                key="create"
                loading={isLoading}
                type="primary"
                label="Create"
                onClick={() =>form.submit()}
              />
            ]}
          >
            {isLoading ? <KoLoader circle={false} /> : <ChildCategoryForm handleFinish={handleFinish} form={form} CategoryId={selectedCategoryId} SubCategoryId={selectedSubCategoryId}/>}
          </KoModal>

          <KoPagination
            current={parseInt(pagination.page) || 1}
            total={totalCount}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
            }
            pageSize={pagination.size}
            defaultCurrent={pagination.page}
            onChange={onPagination}
            showQuickJumper={false}
            simple={false}
            responsive={false}
          />
            
        </div>
      </div>
    </div>
    
    // ---------------------------------------


  );
}
